/**
 * Purpose: Combines all category question files into the complete Family Road Trip question pack.
 * Owns: Pack metadata and question aggregation for the base pack.
 * Notes: Each category file contains 75 questions (5 age groups × 3 tiers × 5 questions).
 *        Total: 600 questions across 8 categories. See CLAUDE.md "Question System" for details.
 */

import type { QuestionPack, Question } from '../../../types/question';

import mathQuestions from './math.json';
import scienceQuestions from './science.json';
import historyQuestions from './history.json';
import englishQuestions from './english.json';
import artQuestions from './art.json';
import geographyQuestions from './geography.json';
import musicQuestions from './music.json';
import sportsQuestions from './sports.json';

/** All 600 questions from the base pack, combined from 8 category files. */
const allQuestions: Question[] = [
  ...(mathQuestions as Question[]),
  ...(scienceQuestions as Question[]),
  ...(historyQuestions as Question[]),
  ...(englishQuestions as Question[]),
  ...(artQuestions as Question[]),
  ...(geographyQuestions as Question[]),
  ...(musicQuestions as Question[]),
  ...(sportsQuestions as Question[]),
];

/** The base "Family Road Trip" question pack with all 600 curated questions. */
const familyRoadTripPack: QuestionPack = {
  packId: 'family-road-trip',
  packName: 'Family Road Trip',
  packDescription: 'The classic family trivia pack for all ages — from toddlers to adults!',
  theme: 'classroom',
  questions: allQuestions,
};

export default familyRoadTripPack;
